/* eslint-disable import/prefer-default-export */
export const TabBarHeight = 68;
